export const TEMAS = ['claro', 'oscuro', 'sistema'] as const;
export type Tema = (typeof TEMAS)[number];

const CLAVE_GUARDADA = 'actualgold.tema';

export function temaGuardado(): Tema {
  const guardado = globalThis.localStorage?.getItem(CLAVE_GUARDADA);
  return TEMAS.find((tema) => tema === guardado) ?? 'sistema';
}

/**
 * Aplica el tema al documento. "Sistema" sigue la preferencia del equipo, que es lo que
 * corresponde en una tablet de mostrador que se oscurece sola de noche.
 */
export function aplicarTema(tema: Tema): void {
  const oscuro =
    tema === 'oscuro' ||
    (tema === 'sistema' &&
      globalThis.matchMedia?.('(prefers-color-scheme: dark)').matches === true);
  document.documentElement.classList.toggle('oscuro', oscuro);
  globalThis.localStorage?.setItem(CLAVE_GUARDADA, tema);
}
